export var EAction = /* @__PURE__ */ ((EAction2) => {
  EAction2["CLICK"] = "click";
  EAction2["VISIBLE"] = "visible";
  return EAction2;
})(EAction || {});
export var EClickElement = /* @__PURE__ */ ((EClickElement2) => {
  EClickElement2["ICON"] = "icon";
  EClickElement2["BUTTON"] = "button";
  EClickElement2["TEXT"] = "text";
  EClickElement2["LINK"] = "link";
  return EClickElement2;
})(EClickElement || {});
export var EVariables = /* @__PURE__ */ ((EVariables2) => {
  EVariables2["EVENT"] = "event";
  EVariables2["CATEGORY"] = "1_category";
  EVariables2["ACTION"] = "2_action";
  EVariables2["LABEL"] = "3_label";
  EVariables2["VALUE"] = "4_value";
  EVariables2["COMPONENT_CATEGORY"] = "component_category";
  EVariables2["COMPONENT_NAME"] = "component_name";
  EVariables2["CLICK_TEXT"] = "click_text";
  EVariables2["CLICK_PATH"] = "click_path";
  EVariables2["CLICK_PATH_PARAMS"] = "click_path_params";
  EVariables2["CLICK_ELEMENT"] = "click_element";
  return EVariables2;
})(EVariables || {});
function initDataLayer() {
  if (process.server || import.meta.server) {
    return [];
  }
  if (!window?.dataLayer) {
    window.dataLayer = [];
  }
  return window.dataLayer;
}
export function pushToDataLayer(data) {
  const dataLayer = initDataLayer();
  dataLayer.push(data);
}
